import { useEffect } from 'react';

import { DEALER_RATING_EVENT, DEALER_RATING_VARIATION_KEYS } from './DealerRatingsExperiment.helpers';

export const DealerRatingsExperimentTestKey = () => {
  useEffect(() => {
    DEALER_RATING_EVENT(DEALER_RATING_VARIATION_KEYS.TEST);
  }, []);

  return (null);
};
